import { keysLower } from "@/core/helpers";
import http from "@/api/services/http.service";

const AdminService = {
  get(path, params) {
    return http.get("/admin" + path, params).then((resp) => keysLower(resp.data));
  },

  post(path, params) {
    return http.post("/admin" + path, params).then((resp) => keysLower(resp.data));
  },

  delete(path, params) {
    return http.delete("/admin" + path, {data: params}).then((resp) => keysLower(resp.data));
  },

  put(path, params) {
    return http.put("/admin" + path, params).then((resp) => keysLower(resp.data));
  },
};

export default AdminService;
